if (!customElements.get('rokid-product-lineup')) {
 class RokidProductLineup extends HTMLElement {
  connectedCallback() {
   if (this.controller) return;
   this.controller = new AbortController();
   const options = {signal: this.controller.signal};
   this.tabs = [...this.querySelectorAll('[role="tab"]')];
   this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
   this.active = 0;
   const select = (index, focus = false) => {
    if (index < 0 || index >= this.tabs.length) return;
    this.active = index;
    this.tabs.forEach((tab, i) => {tab.setAttribute('aria-selected', String(i === index));tab.tabIndex = i === index ? 0 : -1;this.panels[i].hidden = i !== index;});
    if (focus) this.tabs[index].focus({preventScroll: true});
   };
   this.tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => select(index), options);
    tab.addEventListener('keydown', event => {
     const positions = {ArrowLeft:(index - 1 + this.tabs.length) % this.tabs.length, ArrowRight:(index + 1) % this.tabs.length, Home:0, End:this.tabs.length - 1};
     if (event.key in positions) {event.preventDefault();select(positions[event.key], true);}
    }, options);
   });
   this.addEventListener('shopify:block:select', event => {
    const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
    select(index);
   }, options);
   const swipe = this.querySelector('.rk-lineup__swipe');
   let gesture = null, suppressUntil = 0;
   const clear = () => {
    if (gesture?.axis === 'x') suppressUntil = performance.now() + 400;
    if (gesture && swipe.hasPointerCapture(gesture.id)) swipe.releasePointerCapture(gesture.id);
    gesture = null;
   };
   swipe.addEventListener('pointerdown', event => {
    if (!event.isPrimary) {clear();return;}
    if (event.button !== 0 || event.target.closest('input,textarea,select,[contenteditable=true]')) return;
    suppressUntil = 0;
    gesture = {id:event.pointerId,x:event.clientX,y:event.clientY,axis:null,index:this.active};
   }, options);
   swipe.addEventListener('pointermove', event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
    if (!gesture.axis && Math.max(Math.abs(dx),Math.abs(dy)) >= 12) {
     if (Math.abs(dy) > Math.abs(dx)) gesture.axis = 'y';
     else if (Math.abs(dx) > Math.abs(dy) * 1.3) {gesture.axis = 'x';swipe.setPointerCapture(event.pointerId);}
    }
    if (gesture.axis === 'x' && event.cancelable) event.preventDefault();
   }, options);
   swipe.addEventListener('pointerup', event => {
    if (!gesture || gesture.id !== event.pointerId) return;
    const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
    if (gesture.axis === 'x' && gesture.index === this.active && Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.3) select(this.active + (dx < 0 ? 1 : -1));
    clear();
   }, options);
   swipe.addEventListener('pointercancel', clear, options);
   swipe.addEventListener('lostpointercapture', event => {if(event.target === swipe && gesture?.id === event.pointerId) gesture = null;}, options);
   swipe.addEventListener('click', event => {if(event.detail !== 0 && performance.now() < suppressUntil){event.preventDefault();event.stopPropagation();}}, {...options,capture:true});
   swipe.addEventListener('dragstart', event => event.preventDefault(), options);
   select(0);
  }
  disconnectedCallback() {this.controller?.abort();this.controller = null;}
 }
 customElements.define('rokid-product-lineup', RokidProductLineup);
}
